import styles from './BlockedTeamMemberScreen.module.scss';
import mobileBackground from 'src/images/backgrounds/mobile_BG.png';
import desktopBackground from 'src/images/backgrounds/desktop_BG.png';
import { Modal } from 'src/components/Modal';
import { Button } from 'src/v2/commonComponents/Button';
import { useBreakpoint, useGetUser, useLogout, useTeamInfo } from 'src/hooks';
import { sendGTMEvent } from 'src/utils';
import { AppRoutes, GTMEvent } from 'src/types';
import { useNavigate } from 'react-router-dom';
import { useLeaveWorkspaceMutation } from 'src/store/services';
import log from 'src/utils/logger';

export const BlockedTeamMemberScreen = () => {
  const { isMobile } = useBreakpoint();
  const { user_id } = useGetUser();
  const { teamInfo } = useTeamInfo();
  const { logout } = useLogout();
  const navigate = useNavigate();
  const [leaveWorkspace, { isLoading }] = useLeaveWorkspaceMutation();

  const handleLeaveWorkspaceClick = async () => {
    try {
      await leaveWorkspace({
        user_id: user_id,
        team_id: teamInfo?.team_id || '',
      }).unwrap();
      navigate(AppRoutes.HOME, { replace: true });
    } catch (e) {
      log.error('error', e);
    }
  };

  const handleSignOutClick = () => {
    sendGTMEvent(GTMEvent.LOG_OUT);
    logout();
  };

  return (
    <div
      className={styles.root}
      style={{
        backgroundImage: isMobile
          ? `url(${mobileBackground})`
          : `url(${desktopBackground})`,
        backgroundSize: 'cover',
      }}
    >
      <Modal
        open={true}
        onClose={() => {
          // do nothing
        }}
        closeOnOverlayClick={false}
        showCloseIcon={false}
        overlayClassName={styles.overlay}
        className={styles.modal}
      >
        <div className={styles.modalContent}>
          <h3 className={styles.title}>Workspace payment declined</h3>
          <span className={styles.description}>
            We are working with the workspace owner to renew the subscription.
            Please contact your workspace owner if you need immediate access.
          </span>
          <div className={styles.buttonRow}>
            <Button
              onClick={handleLeaveWorkspaceClick}
              color="link"
              disabled={isLoading}
            >
              Leave workspace
            </Button>
            <Button onClick={handleSignOutClick} disabled={isLoading}>
              Sign out
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};
